import React, {FC} from 'react';
import Xarrow from 'react-xarrows';
import {useTaskView} from '../context/task_view.context';
import {getArrows} from './getArrows';

type ArrowsProps = {
  scale: number
};

const ARROW_PATH = 'grid';
const ARROW_COLOR = '#d7d7d7';
const ARROW_WIDTH = 2;

const Arrows: FC<ArrowsProps> = ({scale}) => {
  const {formattedTasks} = useTaskView();

  if (!formattedTasks?.length) {
    return null;
  }

  const arrows = getArrows(formattedTasks);

  return (
    <>
      {arrows.map(({start, end, startAnchor = 'auto', endAnchor = 'auto'}, index) => (
        <Xarrow
          start={start}
          end={end}
          startAnchor={startAnchor}
          endAnchor={endAnchor}
          strokeWidth={ARROW_WIDTH * scale}
          path={ARROW_PATH}
          color={ARROW_COLOR}
          key={`arrow_${index}`}
        />
      ))}
    </>
  );
};

export default Arrows;
